import React, { useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skltn = () => {

    const [state, setState] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])

    return (
        <>
            {state.map(info =>
                <div className="webinarItem skltn-lotterycard">
                    <div className="picture">
                        <Skeleton animation="wave" width={310} height={185} />
                    </div>
                    <div className="details">
                        <div className="desc">
                            <Skeleton animation="wave" width={90 + '%'} height={26} />
                            <span>درباره وبینار:</span>
                            <p>
                                <Skeleton animation="wave" width={60 + '%'} height={22} />
                                <Skeleton animation="wave" width={70 + '%'} height={22} />
                                <Skeleton animation="wave" width={80 + '%'} height={22} />
                            </p>
                        </div>
                        <div className="time">
                            <span>تاریخ شروع: <b><Skeleton animation="wave" width={80 + '%'} height={22} /></b></span>
                            <span>زمان برگزاری: <b><Skeleton animation="wave" width={80 + '%'} height={22} /></b></span>
                        </div>
                    </div>
                    <div className="seeMore">
                        <Skeleton animation="wave" width={100} height={30} />
                    </div>
                </div>
            )}
        </>
    );
}

export default Skltn;